import { HeadCell, NANNY_IN_BOOKING_TYPE } from 'models';

export const headCells: readonly HeadCell<NANNY_IN_BOOKING_TYPE>[] = [
  {
    id: 'nannyName',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Nanny Name',
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Email',
  },
  {
    id: 'number',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Phone',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Nanny status',
  },
];
